export default __webpack_public_path__ + "static/home-bg-118907f8968cf94d6ae55005fb085a94.jpg";